/**
 * 加盟店側-ユーザー追加完了画面
 */
import React from "react";

import { Container } from "@material-ui/core";

import { useContainerStyles } from "../../../../templates/styles";
import { completeStyles } from "../../../../common/components/styles";

import { GUEST_COLOR } from "../../../../../constants/common";

import Dashboard from "../../../../templates/Dashboard";
import CustomBreadcrumbs from "../../../../common/components/molecules/CustomBreadcrumbs";

const GuestSettingUserNewCompletePage: React.FC = () => {
  const classes = completeStyles();
  const containerClasses = useContainerStyles();

  const breadCrumbs = [
    { name: "設定", link: "/guest/setting" },
    { name: "ユーザー管理・検索", link: "/guest/setting/user" },
    { name: "ユーザー追加", link: "/guest/setting/user/new" },
    { name: "完了", link: "" },
  ];

  return (
    <Dashboard
      title="設定"
      color={GUEST_COLOR.base}
      backgroundColor={GUEST_COLOR.primary}
      iconName="setting"
    >
      <Container maxWidth="lg" className={containerClasses.container}>
        <CustomBreadcrumbs breadCrumbs={breadCrumbs} />
        <div className={classes.message}>
          ユーザーの追加が完了しました。
          <br />
          メールをご確認ください。
        </div>
      </Container>
    </Dashboard>
  );
};

export default GuestSettingUserNewCompletePage;
